<template>
  <!-- 员工工资表上传 -->
  <div>
    <dialogModel
      title="提交多人"
      width="1200px"
      :visible="VisibleUp"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <div class="section-row">
            <div class="section-block section-left">
              <div class="section-title">企业信息</div>
              <el-form-item label="企业名称：" prop="Purchaser" :required="true">
                <el-select
                  v-model="ruleForm.Purchaser"
                  @change="handelChange"
                  placeholder="请选择企业名称"
                  value-key="companyName"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="统一社会信用代码："
                prop="PurchaserCode"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserCode }}</div>
              </el-form-item>

              <el-form-item
                label="法定代表人(负责人)："
                prop="PurchaserName"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserName }}</div>
              </el-form-item>

              <el-form-item
                label="企业类型："
                prop="customerCompanyType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerCompanyType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerCompanyType')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="纳税类型："
                prop="PayTaxesType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('PayTaxesType')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>

            <div class="section-block section-right">
              <div class="section-title">支付与上传</div>
              <el-form-item label="上传：" required class="upload-item">
                <div class="upload-box">
                  <ImportRes
                    ref="importRes"
                    :url="UploadUrl"
                    :type="3"
                    :ClearAll="ClearAll"
                    @handleOkImport="handleOkImport"
                    @handleClose="handleClose"
                    @handleClearOut="handleClearOut"
                    @upload-status="onUploadStatus"
                  ></ImportRes>
                  <div class="upload-tip">
                    （上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </dialogModel>
  </div>
</template>

<script>
import { addEmpWagesInfo } from "../../../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import ImportRes from "../InvoiceCom/ImportRes.vue";
export default {
  props: {
    VisibleUp: {},
    InChange: {},
    options1: {}, //平台企业的客户
    enterprise: {}, //平台企业信息
  },
  components: { ImportRes },
  data() {
    return {
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 1, name: "个体户" },
        { id: 4, name: "其它" },
      ], //企业类型选项

      ruleForm: {
        Purchaser: "", //购买方
        PurchaserName: "", //法人
        PurchaserId: "", //购买方
        PurchaserCode: "", //购买方统一代码
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: null, //购买方公司类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址

        PayTaxesType: null, //纳税人类型
      },
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "请选择企业",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserName: [
          {
            required: true,
            message: "法人姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        customerCompanyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      options: [{ label: "xx", value: "1" }], //公司选择
      resList: [],
      UploadUrl: "",
      ClearAll: false,
      uploading: false,
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    VisibleUp: {
      handler(newSs, old) {
        if (newSs == false) {
          this.resList = [];
          this.ClearAll = true;
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          this.ruleForm = {
            Purchaser: "", //购买方
            PurchaserName: "", //法人
            PurchaserId: "", //购买方
            PurchaserCode: "", //购买方统一代码
            PurchaserPhone: "", //购买方联系电话
            customerCompanyType: null, //购买方公司类型
            PurchaseBankName: "", //购买方开户银行名称
            PurchaseAccount: "", //购买方开户账号
            PurchaseAddress: "", //购买方地址

            PayTaxesType: null, //纳税人类型
          };
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        } else {
          this.ClearAll = false;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.UploadUrl = "/global/proxy/empWagesUpload";
  },
  methods: {
    onUploadStatus(status) {
      this.uploading = !!status;
    },
    //点击已上传文件后方的x
    handleClearOut() {
      this.resList = [];
    },
    //选择购买方
    handelChange(val) {
      this.EnterpriseIsItOptional= true //企业类型是否可选
      this.PayTaxesIsItOptional =  true //纳税类型是否可选
      console.log(val, this.ruleForm.Purchaser, "val");
      this.ruleForm.Purchaser = val.companyName;
      this.ruleForm.PurchaserCode = val.customerCreditCode;
      this.ruleForm.PurchaserPhone = val.phone;
      this.ruleForm.PurchaserId = val.id;
      this.ruleForm.PurchaserName = val.legalPerson;
      this.ruleForm.customerCompanyType = val.customerCompanyType;
      this.ruleForm.PurchaseBankName = val.customerBankName;
      this.ruleForm.PurchaseAccount = val.customerBankAccount;
      this.ruleForm.PurchaseAddress = val.customerCompanyAddress;
      this.ruleForm.PayTaxesType = val.customerTaxType;
      this.$refs.ruleForm.clearValidate();
      if (val.customerCompanyType !== null && val.customerCompanyType !== "") {
        // 自动选中企业类型，不可在修改
        this.EnterpriseIsItOptional = false;
      }
      if (val.customerTaxType !== null && val.customerTaxType !== "") {
        // 自动选中纳税类型，不可在修改
        this.PayTaxesIsItOptional = false;
      }
    },
    // 上传完成
    handleOkImport(res) {
      const data = res && res.data && res.data.data;
      this.resList = Array.isArray(data)
        ? data
        : data && Array.isArray(data.businessDataList)
        ? data.businessDataList
        : [];
      if (!this.resList.length) {
        this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
        // 仅提示，不清空上传组件，避免先错后对时把新选文件冲掉；再次选择会走替换上传
      }
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      if (this.uploading) {
        this.$tool.PromptBox("warning", "文件上传中，请稍候再确认");
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.resList.length > 0) {
            var data = {
              data: {
                // buyCompanyId: 0,//
                buyCompanyName: this.enterprise.companyName, //平台企业名称
                buyCreditCode: this.enterprise.customerCreditCode, //平台社会信用代码
                buyCompanyPhone: this.enterprise.phone, //平台公司电话
                orderCompanyName: this.ruleForm.Purchaser, //订单企业名称
                orderCreditCode: this.ruleForm.PurchaserCode, //订单公司信用代码
                orderCompanyType: this.ruleForm.customerCompanyType, //订单企业类型
                orderTaxType: this.ruleForm.PayTaxesType, //订单纳税类型
                orderLegalPersonName: this.ruleForm.PurchaserName, //订单法人名称
                modelList: this.resList,
              },
            };
            API.addEmpWagesInfo(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.$emit("handleConfirmUp");
              }
            });
          } else {
            this.$tool.PromptBox(
              "error",
              "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-form-dialog.less";
</style>
